import React, { useState, useEffect } from "react";
import "../App.css"

// Libraries
import ReactLoading from 'react-loading';
import MerkleTree from 'merkletreejs';
import keccak256 from 'keccak256';
import Web3 from "web3";
import detectEthereumProvider from '@metamask/detect-provider';

import mintedimg from "../images/mintedimg.png"
import totalcollection from "../images/totalcollection.png"
import MintingBtn from "./MintingBtn";
import img2 from "../images/img-2.png"
import Navbar from "./Navbar";
import Footer from "./Footer";

import logo from "../images/logo.png"
import discord from "../images/icon-discord.png"
import insta from "../images/icon-insta.png"
import twitter from "../images/icon-twitter.png"
import arrow from "../images/arrow.png"
import opensea from "../images/icon-opensea.png"


// Components
import abi from "../utility/abi.json";
import { WLAddresses } from '../utility/WLaddresses';

require("dotenv").config();

const { REACT_APP_CONTRACT_ADDRESS } = process.env;

const SELECTEDNETWORK = "1";
const SELECTEDNETWORKNAME = "Ethereum";
const nftquantity = 1143;

function Mintingpage() {

    const [counter, setCounter] = React.useState(0);
    const [showCounder, setShowCounder] = React.useState(false);
    const [showConnectWallet, setShowConnectWallet] = React.useState(false);

    const [errormsg, setErrorMsg] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [totalSupply, settotalSupply] = useState(0);

    const [status, setStatus] = useState(0);
    const [account, setAccount] = useState('')
    const [isConnected, setisConnected] = useState(false);
    const [isLoading, setisLoading] = useState(false);

    const [value, setValue] = useState(0);
    const [HexProofMain, setHexProofMain] = useState(null);
    const [statusMessage, setStatusMessage] = useState("")
    const [round, setRound] = useState("0")

    useEffect(() => {
        getTotalSupply()
    }, []);

    const handleDecrement = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1);
        }
    };


    const handleIncrement = () => {
        if (status === 1 ? quantity < 4 : quantity < 1) {
            setQuantity(quantity + 1);
        }
    };

    async function getTotalSupply() {
        window.web3 = new Web3(window.ethereum);
        const web3 = window.web3;
        if (await web3.eth.net.getId() == SELECTEDNETWORK) {

            const contractaddress = REACT_APP_CONTRACT_ADDRESS;
            const ct = new web3.eth.Contract(abi, contractaddress);
            settotalSupply(await ct.methods.totalSupply().call());
            setRound(await ct.methods.getStatus().call())
            // setRound("2")
        }

    }

    async function connectMetaMask() {

        if (!window.ethereum) {
            window.location.assign("https://metamask.app.link/dapp/https://artaxia-nft.netlify.app/Mint")
            return
        }

        if (process.browser) {
            const ethereum = window.ethereum;
        }

        await window.ethereum
            .request({ method: "eth_requestAccounts" })
            .then(handleAccountsChanged)
            .catch((err) => {
                if (err.code === 4001) {
                    // EIP-1193 userRejectedRequest error
                    // If this happens, the user rejected the connection request.
                    console.log("Please connect to MetaMask.-----");
                    setErrorMsg("Please connect to MetaMask.");
                } else {
                    console.error(err);
                }
            });
    }

    async function handleAccountsChanged(accounts) {
        if (accounts.length === 0) {
            // MetaMask is locked or the user has not connected any accounts
            console.log("Please connect to MetaMask.");
            setErrorMsg("Please connect to MetaMask.");

        } else if (accounts[0] !== account) {
            let metaMaskAccount = accounts[0];
            console.log(metaMaskAccount);
            if (metaMaskAccount) {
                setAccount(metaMaskAccount);
                fetch(metaMaskAccount);
            } else {
                setErrorMsg("Connect Your wallet");
            }
        } else {
            let metaMaskAccount = accounts[0];
            setAccount(metaMaskAccount);
            fetch(metaMaskAccount);

        }
    }

    async function fetch(metamakAcc) {

        // setProvider(true);
        setisLoading(true)
        window.web3 = new Web3(window.ethereum);
        const web3 = window.web3;
        if (await web3.eth.net.getId() == SELECTEDNETWORK) {

            const contractaddress = REACT_APP_CONTRACT_ADDRESS;
            const ct = new web3.eth.Contract(abi, contractaddress);
            settotalSupply(await ct.methods.totalSupply().call());

            if (nftquantity - await ct.methods.totalSupply().call() == 0) {
                setErrorMsg("Phase 1 : All NFTs minted, Sale has ended");
            }

            let statusValue = await ct.methods.getStatus().call()
            // let statusValue = "1";

            console.log("status", statusValue)
            if (statusValue === '0') {
                console.log("Sale is not Active");
                setErrorMsg("SALE IS NOT ACTIVE");
                setStatus(0)
                return;
            } else if (statusValue === '1') {
                setStatus(1);
                // setStatusMessage("Holders Sale");
                console.log("White-List is on");
                await hash(metamakAcc);
                return;
            } else if (statusValue === '2') {
                setStatus(2);
                // setStatusMessage("Public Sale : Max 10 NFTs allowed Max / Wallet");
                console.log("public-list is on");
                setisConnected(true)
                return;
            }
        }
        else {
            // setProvider(false);
            setErrorMsg("Select \"" + SELECTEDNETWORKNAME + "\" network in your wallet to buy the nft");
        }
    }

    async function hash(metamakAcc) {

        const leafNodes = WLAddresses.map(addr => keccak256(addr));
        const markleTreeT = new MerkleTree(leafNodes, keccak256, { sortPairs: true });
        const rootHash = markleTreeT.getHexRoot();
        // console.log("Root hash ----> ", rootHash)

        // console.log("account -- > ", metamakAcc)

        const addressChecker = keccak256(metamakAcc).toString('hex')
        const HexProof = markleTreeT.getHexProof(addressChecker);


        if (HexProof.length > 0) {
            setHexProofMain(HexProof)
            setisLoading(false)
            setisConnected(true);

        } else {
            setisLoading(false);
            setErrorMsg("You are not whitelisted");
        }
    }


    async function loadWeb3White() {

        console.log("White list Sale ---- > ")

        if (await detectEthereumProvider()) {
            window.web3 = new Web3(window.ethereum);
            await window.ethereum.enable();
            const web3 = window.web3;
            // Meta Mask Connected Account Address


            if (await web3.eth.net.getId() == SELECTEDNETWORK) {
                // // creating contract instance
                const contractaddress = REACT_APP_CONTRACT_ADDRESS;
                const ct = new web3.eth.Contract(abi, contractaddress);

                let current = await ct.methods.totalSupply().call();
                if (Number(current) === nftquantity) {
                    console.log("Sold out");
                    return;
                }
                let price = await ct.methods.getWhitelistPrice(quantity).call();
                console.log("Quantity ----- > ", quantity)
                await ct.methods.purchaseWhiteListTokens(quantity, HexProofMain).send({ from: account, value: price });

                settotalSupply(await ct.methods.totalSupply().call());
                setQuantity(1);
            } else { setErrorMsg("Select \"" + SELECTEDNETWORKNAME + "\" network in your wallet to buy the nft") };
        } else if (window.web3) {
            window.web3 = new Web3(window.web3.currentProvider);
        } else {
            { setErrorMsg("browser not detected. You should consider trying MetaMask!") }
        }
    }

    async function loadWeb3Public() {

        console.log("Public Sale ---- > ")

        if (await detectEthereumProvider()) {
            window.web3 = new Web3(window.ethereum);
            await window.ethereum.enable();
            const web3 = window.web3;
            // Meta Mask Connected Account Address

            if (await web3.eth.net.getId() == SELECTEDNETWORK) {
                // // creating contract instance
                const contractaddress = REACT_APP_CONTRACT_ADDRESS;
                const ct = new web3.eth.Contract(abi, contractaddress);

                let current = await ct.methods.totalSupply().call();
                if (Number(current) === nftquantity) {
                    console.log("Sold out");
                    return;
                }
                let price = await ct.methods.getPrice(quantity).call();
                await ct.methods.mint(quantity).send({ from: account, value: price });

                settotalSupply(await ct.methods.totalSupply().call());
                setQuantity(1);
            } else { setErrorMsg("Select \"" + SELECTEDNETWORKNAME + "\" network in your wallet to buy the nft") };
        } else if (window.web3) {
            window.web3 = new Web3(window.web3.currentProvider);
        } else {
            { setErrorMsg("browser not detected. You should consider trying MetaMask!") }
        }
    }

    async function mintArtaxiaNFT() {

        if (status === 1) {
            loadWeb3White()
        } else if (status === 2) {
            loadWeb3Public()
        }
    }



    return (
        <div className="mintingBg pb-5" id="#Minting">
            {/* <div className="othernavbar"> */}
            <div className="container">
                <div className="pt-3">
                    <Navbar />
                </div>

            </div>
            {/* </div> */}
            <div className="freespace"></div>
            <div className="container">

                <div className="row pt-5 pb-5">
                    <div className="col-md-7 pt-5 minttext">

                        {round === "0"
                            ?
                            <h1 className="">MINT<span>-PAUSED</span></h1>
                            :
                            round === "1" ? <>

                                <h1 className="">MINT<span>-1ST</span> ROUND</h1>
                                <p>
                                    WL- People are able to Mint Max 4 NFTs for free per Wallet.
                                </p>
                            </> : <>
                                <h1 className="">MINT<span>-2ND</span> ROUND</h1>
                                <p>
                                    PUBLIC STARTS after Round 1<br />
                                    {/* .01 mint price / 10 Max Per Wallet */}
                                    Free mint / 1 Max Per Wallet

                                </p>
                            </>}

                        <div className="row">
                            <div className="col-md-12 twoimages pt-5">
                                <div className="minted text-center">
                                    <img className="" src={mintedimg}></img>
                                    <h3>{totalSupply} MINTED</h3>
                                </div>
                                <div className="totalcollection text-center">
                                    <img className="" src={totalcollection}></img>
                                    <h3>{nftquantity} Total Collection</h3>
                                </div>
                            </div>
                        </div>

                        {!errormsg ?
                            <>
                                {isConnected ? <>

                                    <div className="row">
                                        <div className="col-md-12 pt-5">

                                            <section class=" pb-lg-0 banner2" id="mintsection">
                                                <div class="container">
                                                    <div>
                                                        <div class="container-fluid ml-0 p-0 heroContainer" >
                                                            <div class="row">
                                                                <div class="leftSide py100 col-12">
                                                                    <div className="d-flex justify-content-center pt-3" >
                                                                        <span className="d-flex walletBtn_mint" >
                                                                            <div class=" d-flex mr-sm-5 justify-content-center align-items-center">
                                                                                <div class="signBtn pl-2" onClick={() => handleDecrement()}>
                                                                                    <img className="" src={arrow}></img>
                                                                                </div>
                                                                                <h2 class="number px-0">{quantity}</h2>
                                                                                <div class="signBtn" onClick={() => handleIncrement()}>
                                                                                    <img className="arrowup" src={arrow}></img>
                                                                                </div>
                                                                            </div>
                                                                            <a onClick={() => { mintArtaxiaNFT() }}
                                                                                class="walletBtn1 border-0 m-1 px-3 ml-sm-5 ml-0  d-flex justify-content-center align-items-center">
                                                                                <p>MINT ARTAXIA</p>
                                                                            </a>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>

                                        </div>
                                    </div>
                                    <br />
                                    <br />

                                    {/* <div className="row">
                                        <div className="col-md-12 text-center pt-3">
                                            <h5 className="totalsupply">{statusMessage}</h5>
                                        </div>
                                    </div> */}

                                </> : <>
                                    <br />
                                    {/* <br /> */}
                                    <section class=" pb-lg-0 banner2" id="mintsection">
                                        <div class="container">
                                            <div>
                                                <div class="container-fluid ml-0 p-0 heroContainer" >
                                                    <div class="row">
                                                        <div class="leftSide py100 col-12 ">
                                                            <div className="d-flex justify-content-center pt-3" >
                                                                <span className="d-flex walletBtn_mint_connect" >

                                                                    <a onClick={() => { connectMetaMask() }}
                                                                        class="walletBtn1 border-0 m-1 px-3 ml-0  d-flex justify-content-center align-items-center">
                                                                        <p>Connect Wallet</p>
                                                                    </a>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    {isLoading && <>
                                        <br />
                                        <div style={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                                            <ReactLoading type={'bars'} color={'#fff'} height={'28px'} width={'28px'} />
                                        </div>
                                    </>
                                    }

                                </>}
                            </> :
                            <>
                                <br />
                                <br />
                                <div className="row">
                                    <div className="col-md-12 text-center pt-3">
                                        <h5 className="errorMessage">{errormsg}</h5>
                                    </div>
                                </div>
                            </>
                        }
                    </div>


                    {/* <div className="col-md-1"></div> */}
                    <div className="col-md-5">
                        <img className="w-100 mint-banner-img" src={img2}></img>
                    </div>
                </div>
                <div className="row pt-5 mt-5">
                    <div className="col-md-12 text-center">
                        <img className="" src={logo}></img>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-6">
                        <div className="footer-nav pt-5">
                            <ul className="footer-nav-link">
                                <a href="/">
                                    <p>Home</p>
                                </a>
                                <a href="#about">
                                    <p>About</p>
                                </a>
                                <a href="#promise">
                                    <p>Promises</p>
                                </a>
                                <a href="#team">
                                    <p>Team</p>
                                </a>
                                {/* <a href="#faq">
                                    <p>Faq</p>
                                </a> */}
                            </ul>
                        </div>
                        <div className="footer-icons text-center">
                            <a href="https://twitter.com/_TomCatJr_" target="_blank" >
                                <img className="mr-3 discord" src={twitter}></img>
                            </a>
                            <a href="https://discord.gg/2kQ94Nt5p7" target="_blank" >
                                <img className="mr-3 discord" src={discord}></img>
                            </a>
                            <a href="https://www.instagram.com/dirtytacoandtequila/?hl=en" target="_blank" >
                                <img className="mr-3 discord" src={insta}></img>
                            </a>
                            <a href="https://opensea.io/collection/artaxianft" target="_blank" >
                                <img className="discord" src={opensea}></img>
                            </a>
                        </div>
                    </div>
                    <div className="col-md-3"></div>
                </div>
            </div>
        </div>
    )
}
export default Mintingpage;